import checkAuthenticated from '@/router/middlewares/checkAuthenticated';
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/devices',
    name: 'DevicesView',
    component: () =>
      import(
        /* webpackChunkName: "devicesView" */ '../modules/devices/components/DevicesView'
      ),
    meta: {
      moduleId: 'devices',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    props: true,
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/devices/:id',
    name: 'DevicesForm',
    component: () =>
      import(
        /* webpackChunkName: "devicesForm" */ '../modules/devices/components/DevicesForm'
      ),
    meta: {
      moduleId: 'devices',
      ignoreModuleCheck: true,
    },
    props: true,
    beforeEnter: beforeEnterCheck,
  },
  {
    path: '/public/devices/:token',
    name: 'DevicesPublicForm',
    component: () =>
      import(
        /* webpackChunkName: "devicesForm" */ '../modules/devices/components/DevicesPublicForm'
      ),
    props: true,
  },
  {
    path: '/extern/projects/devices/:id',
    name: 'DevicesExternForm',
    component: () =>
      import(
        /* webpackChunkName: "devicesForm" */ '../../src/modules/project/components/DevicesExternForm'
      ),
    props: true,
  },
];
